<template>
<div>
    <div class="hero-slider">
        <div shadow="never" class="card-border">
            <swiper :options="swiperOption">
                <swiper-slide>
                    <div class="banner-home">
                        <img src="/img/sliders/banners/iphone-14.png" alt="iPhone 14" class="img-fluid" />
                        <div class="slider-caption">
                            <h3 class="slider-title">iPhone 14</h3>
                            <router-link :to="{ name: 'search-products', query: { products: 'Iphone' } }" class="slider-btn">Shop Now</router-link>
                        </div>
                    </div>
                </swiper-slide>

                <swiper-slide>
                    <div class="banner-home">
                        <img src="/img/sliders/banners/ipad.png" alt="iPad" class="img-fluid" />
                        <div class="slider-caption">
                            <h3 class="slider-title">iPad</h3>
                            <router-link :to="{
                    name: 'search-products',
                    query: { products: 'IPAD' }
                  }" class="slider-btn">Shop Now</router-link>
                        </div>
                    </div>
                </swiper-slide>

                <swiper-slide>
                    <div class="banner-home">
                        <img src="/img/sliders/banners/apple-watch.png" alt="Apple Watch" class="img-fluid" />
                        <div class="slider-caption">
                            <h3 class="slider-title">Apple Watch</h3>
                            <router-link :to="{ name: 'search-products', query: { products: 'Apple Watch' } }" class="slider-btn">Shop Now</router-link>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="banner-home">
                        <img src="/img/sliders/banners/airpods.png" alt="Air Pods" class="img-fluid" />
                        <div class="slider-caption">
                            <h3 class="slider-title">AirPods</h3>
                            <router-link :to="{
                    name: 'search-products',
                    query: { products: 'apple airpods' }
                  }" class="slider-btn">Shop Now</router-link>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            swiperOption: {
                effect: "fade",
                speed: 1500,
                autoplay: {
                    delay: 3000
                },
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet(index, className) {
                        return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
                    }
                }
            }
        };
    }
};
</script>

<style lang="scss" scoped>
.hero-slider {
    padding: 0 2em;

    .slider-caption {
        position: absolute;
        top: 30%;
        right: 20%;
        padding: 0.625em 1em;

        .slider-title {
            color: #11233f;
            font-size: 1.75em;
            margin-bottom: 1em;
        }

        p {
            color: #000;
        }

        .slider-btn {
            background: #11233f;
            color: #fff !important;
            padding: 8px 15px;
            margin-top: 0.6em;
            display: inline-block;
            text-transform: uppercase;
            font-weight: 400;
            letter-spacing: 1px;
            border-radius: 0.3em 0 0.3em 0;
            transition: all 0.5s ease-in-out;
            line-height: normal;
            font-family: "Poppins", sans-serif;
        }

        .slider-btn:hover {
            background: #e7993c;
        }
    }

    @media (max-width: 768px) {
        padding: 0px;
    }
}
</style>
